import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const GET_LEGAL_ISSS_ALL_REQUEST = "GET_LEGAL_ISSS_ALL_REQUEST";
export const GET_LEGAL_ISSS_ALL_SUCCESS = "GET_LEGAL_ISSS_ALL_SUCCESS";
export const GET_LEGAL_ISSS_ALL_ERROR = "GET_LEGAL_ISSS_ALL_ERROR";

//* ACTIONS ------------------------------------------------
export const getLegalISSSAllRequest = (payload = {}, callback) => ({
  type: GET_LEGAL_ISSS_ALL_REQUEST,
  payload,
  callback,
});

export const getLegalISSSAllSuccess = (data) => ({
  type: GET_LEGAL_ISSS_ALL_SUCCESS,
  payload: data,
});

export const getLegalISSSAllError = (error) => ({
  type: GET_LEGAL_ISSS_ALL_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const getLegalISSSAllServiceRequest = async ({ payrollId, periodId, ...params }) => {
  const options = await withToken({
    method: Methods.GET,
    params,
    headers: { CompanyId: await getUserCompany() },
  });
  return request(`/payrolls/${payrollId}/periods/${periodId}/isss`, options);
};
